import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Actions
import {
    getAssociatedCompanies,
    postAddCompanyToSchema,
    postRemoveCompanyFromSchema,
    getHaveCompnyEnteredData
} from '../../../../../actions/esg'

// Utils
import { translation } from '../../../../../utils/helpers'

// Elements
import RemoveButton from '../../../../../shared/elements/removeButton'
import DropDown from '../../../../../shared/elements/dropDown'
import Label from '../../../../../shared/elements/label'
import AddButton from '../../../../../shared/elements/addButton'
import Grid from '../../../../../shared/elements/grid'

// components
import Portal from '../../../../../shared/components/Portal'
import Confirm from '../../../../../shared/components/Confirm'

// sub-components
import LabelWrapper from '../../../../../shared/elements/labelWrapper'

class CompanySelection extends Component {
  constructor (props) {
    super(props)
    this.state = {
      companies: [],
      confirm: { show: false, onConfirm: () => {} }
    }
  }

  componentDidMount () {
    this.getAssociatedCompanies(this.props.schemaId, this.props.year)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.schemaId !== nextProps.schemaId || this.props.year !== nextProps.year) {
      this.getAssociatedCompanies(nextProps.schemaId, nextProps.year)
    }
  }

  getAssociatedCompanies (schemaId, year) {
    this.props.getAssociatedCompanies(schemaId, year).then((res) => {
      this.setState({ companies: res.data })
    }, () => {
      window.toastr.error(translation('960'), translation('216'))
    })
  }

  render () {
    const renderCompanyType = (department, title) => {
      let selecableCompanies = this.state.companies.filter(x => x.Department === department && !x.IsSelected)
      let selectedCompanies = this.state.companies.filter(x => x.Department === department && x.IsSelected)

      const removeCompany = (companyId) => {
        this.props.postRemoveCompanyFromSchema(this.props.schemaId, this.props.year, companyId).then((res) => {
          this.setState({ companies: res.data })
          // window.toastr.success(translation(893), translation('13424'))
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const onRemoveCompany = (companyId) => {
        this.props.getHaveCompnyEnteredData(this.props.schemaId, this.props.year, companyId).then((res) => {
          if (res.data === false) removeCompany(companyId)
          else this.setState({ confirm: { show: true, onConfirm: () => removeCompany(companyId) } })
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const addCompany = () => {
        if (isNaN(this.state[department])) {
          window.toastr.error(translation(960), translation('216'))
          return
        }
        this.props.postAddCompanyToSchema(this.props.schemaId, this.props.year, this.state[department]).then((res) => {
          this.setState({ companies: res.data, [department]: undefined })
          // window.toastr.success(translation(893), translation('13424'))
        }, () => {
          window.toastr.error(translation(960), translation('216'))
        })
      }

      const renderCompany = (company, index) => {
        return (
          <Grid cols={['auto', 'min-content']} key={index} spacing={1}>
            <Label>{company.CompanyName}</Label>
            <RemoveButton size='s' onClick={() => onRemoveCompany(company.CompanyId)} />
          </Grid>
        )
      }

      return (
        <LabelWrapper labelText={title}>
          <Grid cols={['auto', 'min-content']} gap={2} spacing={2}>
            <DropDown value={this.state[department]} onChange={({ target: { value } }) => this.setState({ [department]: value })}>
              <option value='0'>{translation('1896')}</option>
              {selecableCompanies.map((company, k) => {
                return <option key={k} value={company.CompanyId}>{company.CompanyName}</option>
              })}
            </DropDown>
            <AddButton onClick={addCompany} />
          </Grid>
          {selectedCompanies.map(renderCompany)}
        </LabelWrapper>
      )
    }

    const onConfirmClose = () => this.setState({ confirm: { show: false, onConfirm: () => {} } })
    const onConfirm = () => { this.state.confirm.onConfirm(); onConfirmClose() }
    return (
      <div>
        {renderCompanyType(1, 15364)}
        {renderCompanyType(0, 18409)}
        {this.state.confirm.show !== false && (
          <Portal className='confirmModal' onPortalClose={onConfirmClose}>
            <Confirm confirm={onConfirm} notConfirm={onConfirmClose} higher renderText={() => translation(18419)} confirmText={() => translation(786)} notConfirmText={() => translation(570)} />
          </Portal>
        )}
      </div>
    )
  }
}

CompanySelection.propTypes = {
  schemaId: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired
}

export default connect(null, {
  getAssociatedCompanies,
  postAddCompanyToSchema,
  postRemoveCompanyFromSchema,
  getHaveCompnyEnteredData
})(CompanySelection)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Chain/View/components/companySelection.js